import config from 'common-module/src/config';
import { resolveUrl } from '@zk/framework-vue';
import { snakeCase } from 'lodash';

const getEntryUrl = (name, app) => {
  let entry = app?.url || config[`VUE_APP_MICRO_ENTRY_URL_${snakeCase(name).toUpperCase()}`];
  if (!entry) {
    entry = resolveUrl(`${config.VUE_APP_MICRO_ENTRY_URL}/${name}/`);
  }
  return entry;
};
const apps = [{
  name: 'kanban',
  activeRule: '/kanban',
  prefetch: true,
  keepalive: false
}, {
  name: 'work',
  activeRule: '/work',
  prefetch: true,
  preload: true,
  keepalive: true
}, {
  name: 'epic',
  activeRule: '/epic',
  prefetch: true,
  preload: true,
  keepalive: true
}, {
  name: 'project',
  activeRule: '/project',
  prefetch: true,
  preload: true,
  keepalive: true
}, {
  name: 'backlog',
  activeRule: '/backlog',
  prefetch: true
}, {
  name: 'setting',
  activeRule: '/setting',
  prefetch: true
}];

export default apps.map(app => ({ ...app, entry: getEntryUrl(app.name, app) }));
